import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { apiFetch } from '../../api/client';
import UbsUniprotComponent from '../../components/ubs-uniprot/UbsUniprotComponent';
import { UbsUniprotInfo } from '../../models/UbsUniprotInfo';

const UbsUniprotPage = (): React.JSX.Element => {
   const location = useLocation();
   const [ubs_info, setUbsInfo] = useState<UbsUniprotInfo>();

   const fetchUbsUniprotInfo = (): void => {
      apiFetch<UbsUniprotInfo>('/api' + location.pathname, { credentials: 'include' })
         .then((data) => {
            setUbsInfo(data);
         })
         .catch((error) => {
            console.error(error);
            setUbsInfo(undefined);
         });
   };

   useEffect(() => {
      fetchUbsUniprotInfo();
   }, [location.pathname]);

   return (
      <article className="md-content__inner md-typeset">
         {ubs_info && (
            <>
               <h1 id="installation">Unified Binding Sites for Uniprot entry {ubs_info.uniprot_id}</h1>

               <UbsUniprotComponent ubs_info={ubs_info} isInsideDbEntryTab={false} />
            </>
         )}
      </article>
   );
};

export default UbsUniprotPage;
